import React from 'react'
import { useTranslation } from 'react-i18next'

import { ZoomButtonContainer, ZoomContainer } from "../Zoom/ZoomStyles"
import ControlsTooltipWrapper from "../ControlsTooltipWrapper"

type FloorsNavigationProps = {
  canSee: boolean
  onPrev?: () => void
  onNext?: () => void
}

type ZoomButtonProps = {
  onClick: () => void
  children: React.ReactNode
  position: 'top' | 'bottom'
}

const ZoomButton: React.FC<ZoomButtonProps> = ({ onClick, children, position }) => {
  return (
    <ZoomButtonContainer
      position={position}
      mapsView={'building'}
      onClick={onClick}
    >
      {children}
    </ZoomButtonContainer>
  )
}

const FloorsNavigation = ({ canSee, onPrev = () => { }, onNext = () => { } }: FloorsNavigationProps) => {
  const { t } = useTranslation()
  if (!canSee) {
    return null
  }
  return (
    <ZoomContainer>
      <ControlsTooltipWrapper title={t('cartography.maps.controls.prev')}>
        <ZoomButton onClick={onPrev} position="top" >
          <i className={'fa-regular fa-angles-up'} style={{fontSize: 16}} />
        </ZoomButton>
      </ControlsTooltipWrapper>
      <ControlsTooltipWrapper title={t('cartography.maps.controls.next')}>
        <ZoomButton onClick={onNext} position="bottom">
          <i className={'fa-regular fa-angles-down'} style={{fontSize: 16}} />
        </ZoomButton>
      </ControlsTooltipWrapper>
    </ZoomContainer>
  )
}

export default FloorsNavigation